// import { simulationListSupporter } from "./index.debug";
const dataSampleMessages = [
  'Selalu Berkarya!', 
  'Halo semuaaanyaa~', 
  ':)',
  '',
  'Yang semangat dong, yang semangat dong!',
  'Quotes hari ini dong kak',
  'cihuyyyyyy',
  'absen bang!',
  'panggil nama aku dong kak',
  'Terus semangat, pantang menyerah, walaupun kita tahu dunia ini terkadang tidak adil',
];
export let listSupporter = [];

export async function handlePreview(manager) {
  if (h.isTrue(manager.get('use_placeholder'))) {
    if(manager.widget.setting['rt_type'] == 'top-supporters') {
      await manager.addMsgOnHead();

      for (var i = 0; i < manager.widget.limit(); i++) { 
        let temp = sampleDataTopSupporter(i,manager.widget.limit() - i);
        // manager.widget.simulationListSupporter.push(temp)
        listSupporter.push(temp)
        manager.addRunningText(temp);
       }

      if (manager.widget.messageBuilder.length > 0) {
        await manager.addMsgOnTail();
        manager.runMarquee()
      }

    } else {
      for (var i = 0; i < manager.widget.limit(); i++) { 
        let temp = sampleDataLatestTips(i, manager)
        manager.addRunningText(temp);
      }

      if (manager.widget.messageBuilder.length > 0) {
        await manager.addMsgOnTail();
        manager.runMarquee();
      }

      manager.updateLatestTips()
    }
  }
  else {
    await manager.loadData();
  }
}

export function sampleDataSimulationLatestTips(point, index) {
  // let quantity = point/100;
  let quantity = getRandomInt(2);
  let data = {
    no: index + 1,
    pageUrl : "trakteer.lab/user",
    icon: `<img src="https://edge-cdn.trakteer.id/images/mix/cendol.png" height="22px">`,
    unit: 'cendol',
    supporter: {
      avatar: "https:\/\/cdn.trakteer.id\/images\/mix\/default-avatar.png",
      display_name: 'Supporter baru' + getRandomInt(3),
      quantity:  quantity,
      support_message: dataSampleMessages[getRandomInt(1)],
      price: quantity * 10000,
    }
  }
  return data;
};

export function sampleDataLatestTips(i, manager){
  let temp = {
    no: i + 1,
    supporter: {
      display_name: 'Supporter ' + (i + 1),
      avatar: "https:\/\/cdn.trakteer.id\/images\/mix\/default-avatar.png",
      quantity:  manager.widget.limit() - i,
      support_message: (i % 2 == 0) ? dataSampleMessages[getRandomInt(1)] : null,
      price: (manager.widget.limit() - i) * 10000,
    },
    icon: `<img src="https://edge-cdn.trakteer.id/images/mix/cendol.png" height="22px">`,
    unitName: 'cendol',
    pageUrl: "trakteer.lab\/seseorang"
  }
  return temp;
}

export function sampleDataTopSupporter(i, point){
  let temp = {
    no: i + 1,
    supporter: {
      supporter_name: 'Supporter ' + (i + 1),
      avatar: "https:\/\/cdn.trakteer.id\/images\/mix\/default-avatar.png",
      sum: point,
    },
    icon: `<img src="https://edge-cdn.trakteer.id/images/mix/cendol.png" height="22px">`,
    unitName: 'cendol',
    pageUrl: "trakteer.lab\/seseorang"
  }
  return temp;
}

export function getRandomInt(length) {
  const characters = '0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
  }
  return parseInt(result);
}
